module.exports = __webpack_public_path__ + "img/ai-assistant-white.418aa85b.png";